import { prop, sortBy } from 'ramda';
import type { ComboboxOptions } from '@library/components/selects';
import type { CreateAdjustmentReasonsAPIResponse } from '@library/types/members/memberAdjustments';

export const transformAdjustmentReasons = ({
  response
}: {
  response: CreateAdjustmentReasonsAPIResponse | undefined;
}): ComboboxOptions => {
  if (!response) {
    return [];
  }

  const adjustmentReasonOptions: ComboboxOptions = response?.data?.map(
    (adjustmentReason) => ({
      label: adjustmentReason.attributes.name,
      value: adjustmentReason.id
    })
  );

  return sortBy(prop('label'), adjustmentReasonOptions);
};
